module.exports = __webpack_public_path__ + "static/media/zoleLose_250_500.72f3785e.png";